<div class="article-type-calculation-rule-list">
  <sc-padding>
    <ng-container>
      <table class="table">
        @for (calculationRule of getNonDeletedCalculationRules(); track calculationRule; let i = $index) {
          <tr>
            <td class="text-selection">{{i+1}}</td>
            <td class="text-selection">
              <app-dictionary-entry-label [model]="calculationRule.name"></app-dictionary-entry-label>
            </td>
            <td class="text-selection">{{calculationRule.precission}}</td>
            <td class="text-selection"><app-dictionary-entry-label [model]="resolveArticleAttributeName(calculationRule.attributeId)"></app-dictionary-entry-label></td>
            <td class="text-selection">{{calculationRule.method}}</td>
            <!-- <td>{{calculationRule.calculationIndex}}</td> -->
            <td>
              <button mat-icon-button (click)="editCalculationRule(calculationRule)">
                <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
              </button>
              <button mat-icon-button (click)="removeCalculationRule(calculationRule)">
                <sc-action-icon iconClass="fa-trash"></sc-action-icon>
              </button>
            </td>
          </tr>
        }
      </table>
    </ng-container>
  </sc-padding>
</div>
